<div class="role-dialog-container">

    <!-- ════════════════════════════════ -->
    <!--  VIEW: CHOOSE ROLE              -->
    <!-- ════════════════════════════════ -->
    <div *ngIf="currentView === 'choose'" class="view-choose">
        <div class="dialog-header">
            <h3 class="dialog-title">Welcome!</h3>
            <button mat-icon-button class="close-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="choose-body">
            <h2 class="welcome-title">How will you use Aluguloo?</h2>
            <p class="welcome-sub">
                Tell us a bit about yourself so we can set up your experience.
            </p>

            <div class="role-cards">
                <!-- Business Customer Card -->
                <button class="role-card" (click)="selectRole('customer')">
                    <div class="role-card-icon">
                        <mat-icon>domain</mat-icon>
                    </div>
                    <h3 class="role-card-title">I'm a Business Customer</h3>
                    <p class="role-card-desc">
                        Rent equipment for your business operations, manage corporate
                        bookings, and track orders.
                    </p>
                    <div class="role-card-arrow">
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </button>

                <!-- Vendor Card -->
                <button class="role-card" (click)="selectRole('vendor')">
                    <div class="role-card-icon vendor">
                        <mat-icon>business</mat-icon>
                    </div>
                    <h3 class="role-card-title">I'm a Vendor</h3>
                    <p class="role-card-desc">
                        List your equipment, manage rentals, track revenue, and grow your
                        business.
                    </p>
                    <div class="role-card-arrow">
                        <mat-icon>arrow_forward</mat-icon>
                    </div>
                </button>
            </div>

            <div class="skip-row">
                <p class="skip-hint">Not a business? &nbsp;</p>
                <button class="skip-btn" type="button" (click)="skipSelection()">Continue as a regular customer</button>
            </div>
        </div>
    </div>

    <!-- ════════════════════════════════ -->
    <!--  VIEW: CUSTOMER FORM            -->
    <!-- ════════════════════════════════ -->
    <div *ngIf="currentView === 'customer'" class="view-form">
        <div class="dialog-header">
            <button mat-icon-button class="back-btn" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h3 class="dialog-title">Business Customer Details</h3>
            <button mat-icon-button class="close-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="form-body">
            <!-- Individual Toggle -->
            <div class="individual-toggle-row">
                <mat-checkbox [(ngModel)]="customerData.isIndividual" name="isIndividual" color="primary">
                    I am an individual customer
                </mat-checkbox>
            </div>

            <h2 class="welcome-title smaller">
                {{ customerData.isIndividual ? 'Tell us about yourself' : 'Tell us about your business' }}
            </h2>

            <form #customerForm="ngForm" (ngSubmit)="submitCustomer(customerForm, $event)" class="form">

                <!-- Your Name -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Your Name</mat-label>
                    <input matInput [(ngModel)]="customerData.firstname" name="firstname" required />
                </mat-form-field>

                <!-- Shared Phone row -->
                <div class="phone-row">
                    <mat-form-field appearance="outline" class="country-select">
                        <mat-label>Country Code</mat-label>
                        <mat-select [(ngModel)]="customerData.accountdetails.countryCode" name="countryCode"
                            panelClass="wide-country-dropdown" disableOptionCentering>
                            <mat-select-trigger>
                                <div class="flex-center" *ngIf="getSelectedCountry() as sel">
                                    <img [src]="sel.flag" class="flag-icon-small" />
                                    {{ sel.name }} ({{ sel.code }})
                                </div>
                            </mat-select-trigger>
                            <mat-option *ngFor="let c of countryList" [value]="c.code">
                                <img [src]="c.flag" class="flag-icon" />
                                {{ c.name }} ({{ c.code }})
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="phone-input">
                        <mat-label>{{ customerData.isIndividual ? 'Phone Number' : 'Business Phone' }}</mat-label>
                        <input matInput type="text" [(ngModel)]="customerData.accountdetails.phoneNumber"
                            name="phoneNumber" [maxlength]="currentPhoneLimit" (keypress)="numberOnly($event)"
                            required />
                    </mat-form-field>
                </div>

                <!-- Shared Email -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ customerData.isIndividual ? 'Email Address' : 'Business Email' }}</mat-label>
                    <input matInput type="email" [(ngModel)]="customerData.accountdetails.emailid" name="emailid"
                        required email pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$" />
                    <mat-error *ngIf="customerForm.controls['emailid']?.hasError('required')">
                        Email is required
                    </mat-error>
                </mat-form-field>

                <!-- Business Specific Fields -->
                <ng-container *ngIf="!customerData.isIndividual">
                    <!-- Company Name -->
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Company Legal Name</mat-label>
                        <input matInput [(ngModel)]="customerData.accountdetails.companyname" name="companyname"
                            required />
                    </mat-form-field>

                    <!-- Company Address -->
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Company Address</mat-label>
                        <textarea matInput [(ngModel)]="customerData.accountdetails.companyAddress"
                            name="companyAddress" rows="2" required></textarea>
                    </mat-form-field>

                    <!-- Trade License No -->
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Trade License No.</mat-label>
                        <input matInput [(ngModel)]="customerData.accountdetails.tradeLicenseNo" name="tradeLicenseNo"
                            required />
                    </mat-form-field>

                    <!-- License Expiry Date -->
                    <div style="position: relative; margin-bottom: 4px">
                        <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 0">
                            <mat-label>License Expiry Date</mat-label>
                            <input matInput type="text" [(ngModel)]="expiryDisplay" name="expiryDate" 
                                (input)="onExpiryInput($event)" (focus)="showExpiryCalendar = true" 
                                (click)="$event.stopPropagation()"
                                placeholder="DD/MM/YYYY" />
                            <mat-icon matSuffix (click)="openExpiryCalendar($event)" style="cursor: pointer; color: #777">calendar_today</mat-icon>
                        </mat-form-field>

                        <!-- Inline Calendar -->
                        <div class="calendar-dropdown" *ngIf="showExpiryCalendar" (click)="$event.stopPropagation()">
                            <div class="calendar-header">
                                <span class="chevron" (click)="prevMonth(); $event.stopPropagation()">&#8249;</span>
                                <div class="header-selectors">
                                    <select [ngModel]="currentMonth" (ngModelChange)="selectMonth($event)" name="calMonth">
                                        <option *ngFor="let m of monthNames; let i = index" [value]="i">{{ m }}</option>
                                    </select>
                                    <select [ngModel]="currentYear" (ngModelChange)="selectYear($event)" name="calYear">
                                        <option *ngFor="let y of years" [value]="y">{{ y }}</option>
                                    </select>
                                </div>
                                <span class="chevron" (click)="nextMonth(); $event.stopPropagation()">&#8250;</span>
                            </div>
                            <div class="calendar-weekdays">
                                <span *ngFor="let d of weekdays">{{ d }}</span>
                            </div>
                            <div class="calendar-grid">
                                <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                                    [class.is-today]="day.isToday" [class.is-past]="day.isPast"
                                    [class.selected]="day.isSelected"
                                    (click)="selectExpiryDay(day); $event.stopPropagation()">{{ day.date }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Issued By -->
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>License Issued By</mat-label>
                        <input matInput [(ngModel)]="customerData.accountdetails.issuedBy" name="issuedBy" required />
                    </mat-form-field>

                    <!-- Trade License Upload -->
                    <div class="upload-wrapper">
                        <input type="file" id="licenseFileCustomer" (change)="onFileSelected($event)"
                            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" class="file-input" />
                        <label for="licenseFileCustomer" class="upload-btn">
                            {{ customerData.accountdetails.companyDocuments?.length ? 'Trade License Selected' : 'Upload
                            Trade License Copy' }}
                            <small>PDF, JPG, JPEG, PNG, DOC up to 10MB</small>
                        </label>

                        <!-- Document Mini Card Preview -->
                        <div class="preview-mini-card-container"
                            *ngIf="customerData.accountdetails.companyDocuments?.length">
                            <div class="template-mini-card">
                                <div class="mini-content">
                                    <!-- Image Preview -->
                                    <img *ngIf="isImage(customerData.accountdetails.companyDocuments[0].name)"
                                        [src]="customerData.accountdetails.companyDocuments[0].url" alt="Preview"
                                        class="preview-img" />

                                    <!-- PDF Preview -->
                                    <div *ngIf="!isImage(customerData.accountdetails.companyDocuments[0].name) && !isDoc(customerData.accountdetails.companyDocuments[0].name)"
                                        class="pdf-preview">
                                        <mat-icon>picture_as_pdf</mat-icon>
                                        <span>PDF Document</span>
                                    </div>

                                    <!-- DOC Preview -->
                                    <div *ngIf="isDoc(customerData.accountdetails.companyDocuments[0].name)"
                                        class="pdf-preview">
                                        <mat-icon>description</mat-icon>
                                        <span>Word Document</span>
                                    </div>

                                    <!-- Action Buttons (Hover) -->
                                    <div class="card-actions">
                                        <a [href]="customerData.accountdetails.companyDocuments[0].url" target="_blank"
                                            mat-icon-button class="action-btn view-btn" matTooltip="View">
                                            <mat-icon>visibility</mat-icon>
                                        </a>
                                        <label for="licenseFileCustomer" class="action-btn edit-btn-label"
                                            matTooltip="Replace">
                                            <mat-icon>edit</mat-icon>
                                        </label>
                                    </div>
                                </div>
                                <div class="template-name">{{ customerData.accountdetails.companyDocuments[0].name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <button class="primary-cta" type="submit" [disabled]="isSubmitting">
                    Get Started
                </button>

                <p class="footer-text">All fields are mandatory.</p>
            </form>
        </div>
    </div>

    <!-- ════════════════════════════════ -->
    <!--  VIEW: VENDOR FORM              -->
    <!-- ════════════════════════════════ -->
    <div *ngIf="currentView === 'vendor'" class="view-form vendor-form-view">
        <div class="dialog-header">
            <button mat-icon-button class="back-btn" (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <h3 class="dialog-title">Vendor Details</h3>
            <button mat-icon-button class="close-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="form-body">
            <h2 class="welcome-title smaller">Tell us about your business</h2>

            <form #vendorForm="ngForm" (ngSubmit)="submitVendor(vendorForm, $event)" class="form">
                <!-- Your Name -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Your Name</mat-label>
                    <input matInput [(ngModel)]="vendorData.firstname" name="firstname" required />
                </mat-form-field>

                <!-- Company Name -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Company Legal Name</mat-label>
                    <input matInput [(ngModel)]="vendorData.accountdetails.companyname" name="companyname" required />
                </mat-form-field>

                <!-- Company Address -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Company Address</mat-label>
                    <textarea matInput [(ngModel)]="vendorData.accountdetails.companyAddress" name="companyAddress"
                        rows="2" required></textarea>
                </mat-form-field>

                <!-- Phone row -->
                <div class="phone-row">
                    <mat-form-field appearance="outline" class="country-select">
                        <mat-label>Country Code</mat-label>
                        <mat-select [(ngModel)]="vendorData.accountdetails.countryCode" name="countryCode"
                            panelClass="wide-country-dropdown" disableOptionCentering>
                            <mat-select-trigger>
                                <div class="flex-center" *ngIf="getSelectedCountry() as sel">
                                    <img [src]="sel.flag" class="flag-icon-small" />
                                    {{ sel.name }} ({{ sel.code }})
                                </div>
                            </mat-select-trigger>
                            <mat-option *ngFor="let c of countryList" [value]="c.code">
                                <img [src]="c.flag" class="flag-icon" />
                                {{ c.name }} ({{ c.code }})
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="phone-input">
                        <mat-label>Business Phone</mat-label>
                        <input matInput type="text" [(ngModel)]="vendorData.accountdetails.phoneNumber"
                            name="phoneNumber" [maxlength]="currentPhoneLimit" (keypress)="numberOnly($event)"
                            required />
                    </mat-form-field>
                </div>

                <!-- Business Email -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Business Email</mat-label>
                    <input matInput type="email" [(ngModel)]="vendorData.accountdetails.emailid" name="emailid" required
                        email pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$" />
                    <mat-error *ngIf="vendorForm.controls['emailid']?.hasError('required')">
                        Email is required
                    </mat-error>
                </mat-form-field>

                <!-- Trade License No -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Trade License No.</mat-label>
                    <input matInput [(ngModel)]="vendorData.accountdetails.tradeLicenseNo" name="tradeLicenseNo"
                        required />
                </mat-form-field>

                <!-- License Expiry Date -->
                <div style="position: relative; margin-bottom: 4px">
                    <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 0">
                        <mat-label>License Expiry Date</mat-label>
                        <input matInput type="text" [(ngModel)]="expiryDisplay" name="expiryDate" 
                            (input)="onExpiryInput($event)" (focus)="showExpiryCalendar = true" 
                            (click)="$event.stopPropagation()"
                            placeholder="DD/MM/YYYY" />
                        <mat-icon matSuffix (click)="openExpiryCalendar($event)" style="cursor: pointer; color: #777">calendar_today</mat-icon>
                    </mat-form-field>

                    <!-- Inline Calendar -->
                    <div class="calendar-dropdown" *ngIf="showExpiryCalendar" (click)="$event.stopPropagation()">
                        <div class="calendar-header">
                            <span class="chevron" (click)="prevMonth(); $event.stopPropagation()">&#8249;</span>
                            <div class="header-selectors">
                                <select [ngModel]="currentMonth" (ngModelChange)="selectMonth($event)" name="calMonth">
                                    <option *ngFor="let m of monthNames; let i = index" [value]="i">{{ m }}</option>
                                </select>
                                <select [ngModel]="currentYear" (ngModelChange)="selectYear($event)" name="calYear">
                                    <option *ngFor="let y of years" [value]="y">{{ y }}</option>
                                </select>
                            </div>
                            <span class="chevron" (click)="nextMonth(); $event.stopPropagation()">&#8250;</span>
                        </div>
                        <div class="calendar-weekdays">
                            <span *ngFor="let d of weekdays">{{ d }}</span>
                        </div>
                        <div class="calendar-grid">
                            <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                                [class.is-today]="day.isToday" [class.is-past]="day.isPast"
                                [class.selected]="day.isSelected"
                                (click)="selectExpiryDay(day); $event.stopPropagation()">{{ day.date }}</span>
                        </div>
                    </div>
                </div>

                <!-- Issued By -->
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>License Issued By</mat-label>
                    <input matInput [(ngModel)]="vendorData.accountdetails.issuedBy" name="issuedBy" required />
                </mat-form-field>

                <!-- Trade License Upload -->
                <div class="upload-wrapper">
                    <input type="file" id="licenseFile" (change)="onFileSelected($event)" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        class="file-input" />
                    <label for="licenseFile" class="upload-btn">
                        {{ vendorData.accountdetails.companyDocuments?.length ? 'Trade License Selected' : 'Upload Trade
                        License Copy' }}
                        <small>PDF, JPG, JPEG, PNG, DOC up to 10MB</small>
                    </label>

                    <!-- Document Mini Card Preview -->
                    <div class="preview-mini-card-container" *ngIf="vendorData.accountdetails.companyDocuments?.length">
                        <div class="template-mini-card">
                            <div class="mini-content">
                                <!-- Image Preview -->
                                <img *ngIf="isImage(vendorData.accountdetails.companyDocuments[0].name)"
                                    [src]="vendorData.accountdetails.companyDocuments[0].url" alt="Preview"
                                    class="preview-img" />

                                <!-- PDF Preview -->
                                <div *ngIf="!isImage(vendorData.accountdetails.companyDocuments[0].name) && !isDoc(vendorData.accountdetails.companyDocuments[0].name)"
                                    class="pdf-preview">
                                    <mat-icon>picture_as_pdf</mat-icon>
                                    <span>PDF Document</span>
                                </div>

                                <!-- DOC Preview -->
                                <div *ngIf="isDoc(vendorData.accountdetails.companyDocuments[0].name)"
                                    class="pdf-preview">
                                    <mat-icon>description</mat-icon>
                                    <span>Word Document</span>
                                </div>

                                <!-- Action Buttons (Hover) -->
                                <div class="card-actions">
                                    <a [href]="vendorData.accountdetails.companyDocuments[0].url" target="_blank"
                                        mat-icon-button class="action-btn view-btn" matTooltip="View">
                                        <mat-icon>visibility</mat-icon>
                                    </a>
                                    <label for="licenseFile" class="action-btn edit-btn-label" matTooltip="Replace">
                                        <mat-icon>edit</mat-icon>
                                    </label>
                                </div>
                            </div>
                            <div class="template-name">{{ vendorData.accountdetails.companyDocuments[0].name }}</div>
                        </div>
                    </div>
                </div>

                <button class="primary-cta" type="submit" [disabled]="isSubmitting">
                    Complete Registration
                </button>

                <p class="footer-text">All fields are mandatory.</p>
            </form>
        </div>
    </div>

</div>